import { useTranslation } from 'react-i18next'
import SimpleButton from '../../../common/SimpleButton'
import PageModal from '../../../common/PageModal'
import GenericTable from '../../../common/GenericTable'
import TooltipedIcon from '../../../common/TooltipedIcon'
import { InformationIcon } from '../../../../icons'
import '../../internal-reports.scss'

const ViewUserModal = (props) => {
  const { t } = useTranslation()
  const { registeredUsersTableData, rowId, closeModal, tableType } = props
  const selectedRecord = registeredUsersTableData.find((record) => record.id === rowId)
  const UNKNOWN_LABEL = t('unknown', { defaultValue: 'Unknown' })
  const renderTooltipText = () => {
    return (
      <div className="tooltip-text">
        <p className="tooltip-body">{t('reports.unknown_country_message_for_users')}</p>
      </div>
    )
  }
  const renderUnknownCell = () => {
    return (
      <div className="info-icon">
        {UNKNOWN_LABEL} <TooltipedIcon icon={<InformationIcon />} tooltipText={renderTooltipText()} orientation="right" />
      </div>
    )
  }

  const userFooterContent = () => {
    return (
      <>
        <SimpleButton className="cancel-button" onClick={closeModal}>
          {t('close')}
        </SimpleButton>
      </>
    )
  }

  return (
    <>
      <PageModal toggle onToggle={closeModal} className="device-modal" title={t('details')} footerContent={userFooterContent()}>
        <div className="registered-devices-modal-content">
          <div className="section-title">{t('general_information').toUpperCase()}</div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('year')}</p>
              <div className="value">{selectedRecord.year}</div>
            </div>
            {tableType === 'month' && (
              <div className="input-wrapper">
                <p className="input-option">{t('month')}</p>
                <div className="value">{selectedRecord.month}</div>
              </div>
            )}
            <div className="input-wrapper">
              <p className="input-option">{t('account_context.account_type')}</p>
              <div className="value">{selectedRecord.accountType}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('coltene_store.cart.total')}</p>
              <div className="value">{selectedRecord.total}</div>
            </div>
          </div>

          <div className="separator" />

          <div className="section-title">{t('countries').toUpperCase()}</div>
          <div className="row-wrapper">
            <GenericTable
              className="countries-table"
              data={selectedRecord.countries.map((c) => ({
                countryName: c.countryName !== 'Unknown' ? c.countryName : renderUnknownCell(c.countryName),
                count: c.count,
              }))}
              headers={[{ title: t('country') }, { title: t('coltene_store.cart.total') }, { title: '' }]}
              keys={['countryName', 'count', '']}
            />
          </div>
        </div>
      </PageModal>
    </>
  )
}

export default ViewUserModal

